<template>
  <div>
    <button class="btn btn-info mb-2" @click.prevent="openModal">
      <i class="fas fa-plus"></i> Thêm
    </button>
    <b-table
      bordered
      head-variant="dark"
      hover
      responsive
      :fields="fields"
      :items="items"
      table-variant="light"
    >
      <template v-slot:cell(tien)="data">
        <b-link href="#" @click="openUpdateModal(data)">{{data.value}}</b-link>
      </template>
      <template v-slot:cell(tungay)="data">{{data.item.tungay | moment('DD/MM/YYYY')}}</template>
      <template v-slot:cell(denngay)="data">{{data.item.denngay | moment('DD/MM/YYYY')}}</template>      
      <template v-slot:cell(action)="data">
         <b-link class="text-primary mr-2" href="#" @click="openUpdateItemModal(data)">
          <i class="fas fa-pencil-alt"></i>
        </b-link>
        
        <b-link class="text-danger" href="#" @click.prevent="deleteItem(data)">
          <i class="fas fa-trash"></i>
        </b-link>
      </template>
    </b-table>
    <b-modal
      v-model="modalShow"
      header-bg-variant="info"
      header-text-variant="light"
      size="xl"
      hide-footer
    >
      <template v-slot:modal-title>
        <div v-if="item.id <= 0">Thêm thông tin hiệu quả công việc</div>
        <div v-else>Cập nhật thông tin hiệu quả công việc</div>
      </template>
      <b-form class="mr-4" autocomplete="off" @submit="ok()">
        <b-form-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">Từ ngày</label>
            <code>*</code>
          </b-col>
          <b-col cols="3">
            <vue-datepicker-local
              style="width: 100%"
              v-model="item.tungay"
              :local="local"
              clearable
              format="DD/MM/YYYY"
            />
          </b-col>
          <b-col cols="1"></b-col>
          <b-col cols="2">
            <label class="mr-2">Đến ngày</label>
          </b-col>
          <b-col cols="3">
            <vue-datepicker-local
              style="width: 100%"
              v-model="item.denngay"
              :local="local"
              clearable
              format="DD/MM/YYYY"
            />
          </b-col>
        </b-form-row>
        <b-form-row class="mb-4">          
          <b-col cols="2">
            <label class="mr-2">Tiền</label>
            <code>*</code>
          </b-col>
          <b-col cols="9">
            <my-currency-input v-model="item.tien" />
          </b-col>
        </b-form-row>
        <b-form-row class="mb-3">
          <b-col cols="11" class="form-inline">
            <div style="flex-grow: 1"></div>
            <b-button class="mr-3" variant="info" v-if="itemIdex == null" @click.prevent="storeItem">
              <i class="fas fa-save mr-2"></i>Lưu
            </b-button>
            <b-button class="mr-3" variant="info" v-else @click.prevent="updateItem">
              <i class="fas fa-save mr-2"></i>Lưu
            </b-button>
            <b-button variant="secondary" @click="closeModal">
              <i class="fas fa-times mr-2"></i>Đóng
            </b-button>
          </b-col>
        </b-form-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import VueDatepickerLocal from "vue-datepicker-local";
import "vue-datepicker-local/dist/vue-datepicker-local.css";
import MyCurrencyInput from "../App/MyCurrencyInput";
export default {
  name: "HopDongLaoDongHieuQua",
  components: {
    MyCurrencyInput,
    VueDatepickerLocal,
  },
  props: ["hopdong"],
  data() {
    return {
      fields: [
        {
          key: "tungay",
          label: "Từ ngày",
        },
        {
          key: "denngay",
          label: "Đến ngày",
        },
        {
          key: "tien",
          label: "Tiền",
        },
        {
          key: "action",
          label: "",
          thStyle: { width: "50px !important" },
        },
      ],
      local: {
        monthsHead: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
          "_"
        ), // months of head
        months: "Th 1_Th 2_Th 3_Th 4_Th 5_Th 6_Th 7_Th 8_Th 9_Th 10_Th 11_Th 12".split(
          "_"
        ), // months of panel
        weeks: "CN_T2_T3_T4_T5_T6_T7".split("_"), // weeks,
      },
      items: [],
      modalShow: false,
      item_null: {
        id: 0,
        employeeContractId: 0,
        tungay: null,
        denngay: null,        
        tien: 0,
      },
      item: {
        id: 0,
        employeeContractId: 0,
        tungay: null,
        denngay: null,        
        tien: 0,
      },
      itemIdex: null,
    };
  },
  created() {
    if (this.hopdong != null) this.initData();
  },
  methods: {
    initData() {
      if (this.hopdong.employeeContractPerformances)
        this.items = JSON.parse(
          JSON.stringify(this.hopdong.employeeContractPerformances)
        );
    },
    findFirst(list, id) {
      const temp = list.find(function (el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.pickListValue;
    },
    openModal() {
      this.item = JSON.parse(JSON.stringify(this.item_null));
      this.itemIdex = null;
      this.modalShow = true;
    },
    openUpdateModal(data) {
      this.item = JSON.parse(JSON.stringify(data.item));      
      this.itemIdex = data.index;
      this.modalShow = true;
    },
    closeModal() {
      this.modalShow = false;
    },
    storeItem(bvModalEvt) {
      if (!this.item.tungay || !this.item.denngay) {
        this.$toast.error("Vui lòng nhập đầy đủ thông tin", "Lỗi", {
          timeout: 2000,
        });
        bvModalEvt.preventDefault();
      } else {
        const myitem = this.item;
        const moment = this.$moment;
        const phucap_exits = this.items.find(function (el) {
          if (
            ((moment(myitem.tungay).isSameOrBefore(el.tungay, "day") &&
              moment(el.tungay).isSameOrBefore(myitem.denngay, "day")) ||
              (moment(el.tungay).isSameOrBefore(myitem.tungay, "day") &&
                moment(myitem.tungay).isSameOrBefore(el.denngay, "day")) ||
              (moment(myitem.tungay).isSameOrBefore(el.denngay, "day") &&
                moment(el.denngay).isSameOrBefore(myitem.denngay, "day")))
          )
            return el;
        });
        if (phucap_exits) {
          this.$toast.error("Phụ cấp đã tồn tại trong thời gian này!", "Lỗi", {
            timeout: 2000,
          });
        } else {
          this.items.push(this.item);
          this.modalShow = false;
        }
      }
    },
    updateItem(bvModalEvt) {
      if (!this.item.tungay || !this.item.denngay) {
        this.$toast.error("Vui lòng nhập đầy đủ thông tin", "Lỗi", {
          timeout: 2000,
        });
        bvModalEvt.preventDefault();
      } else {
        const myitem = this.item;
        const moment = this.$moment;
        const index = this.items.findIndex(function (el) {
          if (
            ((moment(myitem.tungay).isSameOrBefore(el.tungay, "day") &&
              moment(el.tungay).isSameOrBefore(myitem.denngay, "day")) ||
              (moment(el.tungay).isSameOrBefore(myitem.tungay, "day") &&
                moment(myitem.tungay).isSameOrBefore(el.denngay, "day")) ||
              (moment(myitem.tungay).isSameOrBefore(el.denngay, "day") &&
                moment(el.denngay).isSameOrBefore(myitem.denngay, "day")))
          )
            return el;
        });
        if (index >= 0 && index != this.itemIdex) {
          this.$toast.error("Phụ cấp đã tồn tại trong thời gian này!", "Lỗi", {
            timeout: 2000,
          });
        } else {
          this.items[this.itemIdex] = this.item;
          this.items = JSON.parse(JSON.stringify(this.items));          
          this.modalShow = false;
        }
      }
    },
    deleteItem(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              this.items.splice(data.index, 1);              
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function (instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
